// src/core/me/api/meApi.js
import { http } from '../../../shared/api/http';
import { endpoints } from '../../../shared/api/endpoints';

export const meApi = {
  getMe() {
    return http(endpoints.me.get, { method: 'GET' });
  },
};
